import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { valueOrDefault } from 'src/app/shared/commons/Utils';
import { CommonService } from 'src/app/shared/services/common.service';
import { ClientService } from './../../shared/services/client.service';

@Component({
  selector: 'app-transactions-dialog',
  templateUrl: './transactions-dialog.component.html',
  styleUrls: ['./transactions-dialog.component.scss']
})
export class TransactionsDialogComponent implements OnInit {

  type: string
  model: any = {}

  transactions: any = []

  currentPage = 1
  itemsPerPage = 20
  totalItems: any
  hidden = true

  constructor(
    private clientService: ClientService,
    private commonService: CommonService,
    public modalRef: BsModalRef
  ) {
    this.commonService.hidden.subscribe(hidden => {
      this.hidden = hidden
    })
  }

  ngOnInit() {
    this.pageChanged()
  }

  getTransactions() {
    switch (this.type) {
      case 'checking':
      case 'savings':
        this.getTransactionsByAccount()
        break;
      case 'credit_card':
        this.getTransactionsByCards()
        break;
      case 'investments':
        this.getTransactionsByInvestments()
        break;
      default:
        break;
    }
  }

  async getTransactionsByAccount() {
    const filter = {
      page: this.currentPage,
      rows: this.itemsPerPage
    }
    const $res = await this.clientService.getTransactionsByAccount(this.model.uuid, filter)
    this.totalItems = $res?.statistics?.total_rows
    $res?.transactions?.map(item => {
      item.transaction_date = moment.unix(item?.transaction_date)?.toDate()
      item.bank_name = $res?.account?.bank_name
      this.transactions.push(item)
    })
  }

  async getTransactionsByCards() {
    const filter = {
      page: this.currentPage,
      rows: this.itemsPerPage
    }
    const $res = await this.clientService.getTransactionsByCards(this.model.uuid, filter)
    this.totalItems = $res?.statistics?.total_rows
    $res?.transactions?.map(item => {
      item.transaction_date = moment(item?.transaction_date_time)?.toDate()
      item.bank_name = $res?.card?.brand_name
      this.transactions.push(item)
    })
  }

  async getTransactionsByInvestments() {
    const filter = {
      page: this.currentPage,
      rows: this.itemsPerPage
    }
    // const $res = await this.clientService.getTransactionsByInvestments(this.model.uuid, filter)
    // this.totalItems = $res?.statistics?.total_rows
    // $res?.transactions?.map(item => {
    //   item.transaction_date = moment(item?.transaction_date_time)?.toDate()
    //   item.bank_name = $res?.card?.brand_name
    //   this.transactions.push(item)
    // })
  }

  onHidden(e) {
    e.stopPropagation()
    e.preventDefault()
    this.hidden = !this.hidden
    this.commonService.hidden.next(this.hidden)
  }

  pageChanged(page?: any) {
    this.currentPage = valueOrDefault(page, 1)
    this.transactions = []
    this.getTransactions()
  }
}
